import { mutationTypes } from '../../types';
import { BATTERY_STATE } from '../../tools/consts';
import { uiComponents, uiStates } from '../../tools/viewState';
/**
 * First Version of meachnism to set navigation-theme this is for now a copy of the page-theme.
 * Therefor it listens to contentLoading Mutations to detect when a new page is loaded
 */
export default (store) => {
	store.subscribe(async (mutation, state) => {
		if (state.isLoaner && mutation.type === mutationTypes.systemSetBatteryState) {
			if (
				state.systemInfo.batteryState === BATTERY_STATE.FULL ||
				state.systemInfo.batteryState === BATTERY_STATE.CHARGING
			) {
				store.commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.systemInformation,
					uiState: uiStates.maximised,
				});
			}
		}
	});
};
